import PropTypes from 'prop-types'

export const AD_ACCOUNT = 'AD_ACCOUNT'
export const CAMPAIGN = 'CAMPAIGN'
export const AD_GROUP = 'AD_GROUP'
export const KEYWORD = 'KEYWORD'
export const CREATIVE = 'CREATIVE'

export const getDomainText = value => {
  if (value === AD_ACCOUNT) return '광고계정'
  if (value === CAMPAIGN) return '캠페인'
  if (value === AD_GROUP) return '광고그룹'
  if (value === KEYWORD) return '키워드'
  if (value === CREATIVE) return '소재'
  return ''
}
const DomainText = ({ value }) => <>{getDomainText(value)}</>

DomainText.propTypes = {
  value: PropTypes.oneOf([AD_ACCOUNT, CAMPAIGN, AD_GROUP, KEYWORD, CREATIVE]),
}

export default DomainText
